import { useMemo } from 'react';
import { LoginType, useAccountExistenceQuery } from '@websky/graphql';
export const useCustomerInfo = ({ login, isAuthorized, customer }) => {
    var _a;
    const { data, loading } = useAccountExistenceQuery({
        variables: {
            params: {
                login,
                loginType: LoginType.Email
            }
        },
        skip: !login || isAuthorized
    });
    const isAccountExist = !loading && !!((_a = data === null || data === void 0 ? void 0 : data.AccountExistence) === null || _a === void 0 ? void 0 : _a.result);
    const isSubscribed = customer === null || customer === void 0 ? void 0 : customer.subscribed;
    const isShowSubscribeCheckbox = customer === null || customer === void 0 ? void 0 : customer.showSubscribeCheckbox;
    const showSubscribedCheckbox = useMemo(() => {
        return isShowSubscribeCheckbox;
    }, [isAuthorized, isAccountExist, isShowSubscribeCheckbox]);
    return {
        isAccountExist,
        isSubscribed,
        showSubscribedCheckbox
    };
};
